import { Typography } from '@eventr/common-storybook'
import { signal } from '@preact/signals-react'
import { useEffect, useMemo, useRef } from 'react'
import { useGlobalRouter } from '../../feat/globalRouter/useGlobalRouter'
import { NavigationView } from '../../feat/layout/NavigationView'
import { generalTranslation } from '../../i18n/translateHelpers'
import { RendererSplitterTeams } from '../../v2/rendererSplitterTeams'
import { SearchBar } from '../components/carousel/slide/footer/HeaderSearchBar'
import { useTeamSearch } from './hooks/useTeamSearch'
import { TeamMembers } from './TeamMembers'

const searchSignal = signal('')
export const TeamSearchPage = () => {
    const { goBack } = useGlobalRouter()

    const search = useTeamSearch(searchSignal.value)

    // Store the last successful data
    const lastDataRef = useRef<typeof search.data | null>(null)
    useEffect(() => {
        if (search.data) {
            lastDataRef.current = search.data
        }
    }, [search.data])

    // Use current data if available, otherwise fallback to last successful data
    const displayData = search.data ?? lastDataRef.current
    const content = useMemo(() => {
        return (
            <>
                {(displayData?.users ?? []).length > 0 && (
                    <TeamMembers
                        stickyHeader={false}
                        users={displayData?.users ?? []}
                        initOpen={true}
                    />
                )}
                <RendererSplitterTeams
                    openDisclosure
                    stickyHeaders={false}
                    v2Data={displayData?.data?.v2 ?? []}
                />
            </>
        )
    }, [displayData])

    const isEmptyResult = useMemo(() => {
        return (
            searchSignal.value.length > 0 &&
            !search.isLoading &&
            (search.data?.data?.v2?.length ?? 0) === 0 &&
            (search.data?.users?.length ?? 0) === 0
        )
    }, [search])

    return (
        <NavigationView
            usePageTransition
            autoHeaderPadding
            navigationBarTitle={'Search'}
            stickyUnderlay={
                <SearchBar
                    value={searchSignal.value}
                    onChange={(v) => {
                        searchSignal.value = v
                    }}
                    autoFocus
                ></SearchBar>
            }
            backButtonAction={() => {
                goBack()
            }}
        >
            {searchSignal.value.length === 0 && (
                <Typography textAlign={'center'} variant="bodySubtextBold">
                    {generalTranslation('Enter a search term')}
                </Typography>
            )}
            {/* {search.isLoading && !content && (
                <Typography>Loading...</Typography>
            )}
            {!search.isLoading && !search.data && (
                <Typography>No results found.</Typography>
            )} */}
            {searchSignal.value.length > 0 && content}
            {isEmptyResult && (
                <Typography textAlign={'center'} variant="bodySubtextBold">
                    {generalTranslation('No results found')}
                </Typography>
            )}
        </NavigationView>
    )
}
